module.exports = __webpack_public_path__ + "static/О кодексе этики и служебного поведения (ред от 18_01_2019)_0.doc";